/**
 * Returns true if the given url starts with http or https.
 */
export const isExternalUrl = (url: string) => {
    const urlRegex = new RegExp(/^https?:\/\//i);

    return urlRegex.test(url);
};
